module.exports = __webpack_public_path__ + "img/logo.d597d669.png";